// Mirrors estating-api services/family-user-role-service.ts
// Empty list allows any email. 'sub.estating.com' matches 'estating.com', 'notestating.com' does not.
export const emailMatchesDomains = (email?: string, domains?: Array<string>) => {
  if (!domains || domains.length === 0) return true;
  const host = (email ?? '').trim().toLowerCase().split('@')[1];
  if (!host) return false;
  return domains.some((d) => host === d || host.endsWith(`.${d}`));
};
